import { datadogRum } from '@datadog/browser-rum';

import { formatPhoneNumber } from '../utils/phoneUtils';

// eslint-disable-next-line no-undef
const version = process.env.PACKAGE_VERSION;
const env = process.env.NODE_ENV || 'develop';
const REMOTE_CONFIGURATION_ID = '2affa6e4-669d-4de0-bbc5-b6e262fb3ade';

// Taux de replay et suivi (interactions, ressources, tâches longues) :
// réglés dans Datadog, Remote Configuration (cartes #6477 et #6578).
// Ne pas les remettre ici. Taux de sessions : défaut du SDK (100 %).
export const start = () =>
  datadogRum.init({
    applicationId: 'e8e9dc14-3e49-4ca0-9c60-ad987210b46b',
    clientToken: 'pub5173e78e7839c800755afd1e0282c741',
    site: 'datadoghq.com',
    remoteConfiguration: {
      id: REMOTE_CONFIGURATION_ID,
    },
    // Envois et configuration distante par notre domaine : les bloqueurs
    // de publicité refusent les domaines Datadog (carte #6635). Les
    // préfixes /obs et /obs-config doivent rester ceux de nginx.conf.
    proxy: ({ path, parameters }) =>
      `${window.location.origin}/obs${path}?${parameters}`,
    remoteConfigurationProxy:
      `${window.location.origin}/obs-config/${REMOTE_CONFIGURATION_ID}.json`,
    env,
    // Masquage écrit en dur, même s'il vaut le défaut : le défaut a
    // changé entre la v6 et la v7 du SDK, une mise à jour ne doit pas
    // le modifier en silence.
    defaultPrivacyLevel: 'mask-user-input',
    enablePrivacyForActionName: true,
    service: 'v3-front',
    version: `v${version}`,
    // Relie chaque session RUM aux traces APM des appels vers notre back.
    allowedTracingUrls: [
      {
        match: window.location.origin,
        propagatorTypes: ['datadog', 'tracecontext'],
      },
    ],
  });

export const addUserSession = (user) => {
  datadogRum.setUser({
    id: user._id,
    name: user.login,
    ...(user.fingerprint ?
      { userAgent: user.fingerprint?.userAgent } : {}),
  });
  datadogRum.startSessionReplayRecording();
};

export const addAction = (name, context) => {
  if (name && context) {
    datadogRum.addAction(name, context);
  }
};

export const stopSessionReplayRecording = () =>
  datadogRum.stopSessionReplayRecording();

export const trackPhoneReveal = ({
  userId,
  userName,
  phoneNumber,
  entityType,
  context
}) => {
  try {
    if (!userId || !phoneNumber || !entityType || !context) {
      console.warn('[MaskedPhone] Missing required tracking data');
      return;
    }

    addAction('phone_number_revealed', {
      user_id: userId,
      user_name: userName || 'unknown',
      phone_number: phoneNumber,
      phone_number_formatted: formatPhoneNumber(phoneNumber),
      entity_type: entityType,
      page_context: context,
      timestamp: new Date().toISOString()
    });
  } catch (error) {
    console.error('[MaskedPhone] Tracking error:', error);
  }
};

export const trackAudioLinkCopy = ({
  userId,
  userName,
  phoneNumber,
  audioUrl,
  callDate,
  duration,
  service
}) => {
  try {
    if (!userId || !audioUrl) {
      console.warn(
        '[AudioPlayer] Missing required tracking data for link copy'
      );
      return;
    }

    addAction('audio_link_copied', {
      user_id: userId,
      user_name: userName || 'unknown',
      phone_number: phoneNumber || 'unknown',
      phone_number_formatted: phoneNumber ?
        formatPhoneNumber(phoneNumber) : 'unknown',
      audio_url: audioUrl,
      call_date: callDate || 'unknown',
      duration: duration || 0,
      service: service || 'unknown',
      timestamp: new Date().toISOString()
    });
  } catch (error) {
    console.error('[AudioPlayer] Tracking error:', error);
  }
};
